export const RsInspectionGoogleAnalyticsActionName = {
    CancelInspectionAfterAssigned: "rs_insp_cancel_inspection_after_assigned",
    CancelInspectionBeforeAssigned: "rs_insp_cancel_inspection_before_assigned",
    RescheduleInspectionAfterAssigned: "rs_insp_reschedule_inspection_after_assigned",
    RescheduleInspectionBeforeAssigned: "rs_insp_reschedule_inspection_before_assigned",
    ReviseOffer: "rs_insp_revise_offer",
    WithdrawOffer: "rs_insp_withdraw_offer"
}